var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-aside-cart-container" },
    [
      !_vm.disabledButton ? _vm._t("default") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "product-aside-cart-item" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _vm.hasVariants
              ? _c(
                  "fieldset",
                  { attrs: { "aria-labelledby": "variant-label" } },
                  [
                    _c(
                      "legend",
                      {
                        staticClass: "sr-only",
                        attrs: { id: "variant-label" },
                      },
                      [_vm._v("Product variant")]
                    ),
                    _vm._v(" "),
                    _c("VariantDropdown", {
                      attrs: {
                        variants: _vm.product.product_variants,
                        hasVariants: _vm.hasVariants,
                        variantStock: _vm.variantStock,
                        selectedVariant: _vm.selectedVariantRecord,
                      },
                      on: { "variant-selected": _vm.set },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "quantity-controls",
                style: {
                  display: "flex",
                  flexWrap: "wrap",
                  flexGrow: "1",
                  flexDirection: "row",
                  gap: "5px",
                  marginBottom: "5px",
                },
                attrs: { role: "group", "aria-label": "Quantity selector" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "cart-small product-aside-cart-down",
                    attrs: {
                      disabled:
                        _vm.disabledButton ||
                        _vm.disableSubtraction ||
                        _vm.cart_has_max_items_already,
                      type: "button",
                      "aria-label": "Decrease quantity",
                    },
                    on: { click: _vm.decrease },
                  },
                  [_vm._v("-")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.count,
                      expression: "count",
                    },
                  ],
                  staticClass: "product-aside-cart-input",
                  attrs: {
                    type: "number",
                    min: "1",
                    max: _vm.max,
                    "aria-label": "Product quantity",
                    "aria-valuemin": 1,
                    "aria-valuemax": _vm.max,
                    "aria-valuenow": _vm.count,
                  },
                  domProps: { value: _vm.count },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.count = $event.target.value
                      },
                      function ($event) {
                        _vm.count = Math.min(_vm.count, _vm.max)
                      },
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "cart-small product-aside-cart-up",
                    attrs: {
                      disabled:
                        _vm.disabledButton ||
                        _vm.disableAddition ||
                        _vm.cart_has_max_items_already,
                      type: "button",
                      "aria-label": "Increase quantity",
                    },
                    on: { click: _vm.increase },
                  },
                  [_vm._v("+")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn--product-aside",
                    class: { "btn--product-aside-disabled": _vm.addingToCart },
                    attrs: {
                      disabled:
                        _vm.disabledButton || _vm.cart_has_max_items_already,
                      type: "submit",
                      "data-test": "addToCartButton",
                      "aria-label": _vm.cartLabel,
                    },
                    on: { click: _vm.addToCart },
                  },
                  [_vm._v(_vm._s(_vm.cartLabel))]
                ),
              ]
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }